import type { ReactElement } from "react";
import type { Zuordnung } from "@kundeninfo/api-client";
import { Chip } from "@kundeninfo/ui/me-design";
import "./KundenChip.css";

/** Kürzel + Kundennummer je Unternehmensbeziehung — seit ME-Etappe 2 (Aufgabe 4b) ein
 *  `me-chip` (nicht entfernbar). Die Unternehmensfarbe trägt seit Entscheid 41 der Chip
 *  selbst (`farbe`): Fläche, Rand und Schrift leitet das Element ab. Ohne Kundenrolle (reiner
 *  Lieferant) steht nur das Kürzel: Eine nach dem Entfernen der Rolle stehen gebliebene Nummer
 *  (C7) gehört nicht in die Anzeige, ein leeres Nummernfeld auch nicht. */
export function KundenChip({ r, colorHex }: { r: Zuordnung; colorHex: string | undefined }): ReactElement {
  const nummer = r.status === null ? null : r.customerNumber;
  return (
    <Chip className="ka-chip" {...(colorHex !== undefined ? { farbe: colorHex } : {})}>
      <span className="ka-chip__code">{r.shortCode}</span>
      {nummer !== null && (
        <>
          <span className="ka-chip__sep"> · </span>
          <span className="ka-chip__nr">{nummer}</span>
        </>
      )}
    </Chip>
  );
}
